import { useEffect } from "react";
import { useAuthStore } from "@/store/authStore";

export const AuthInitializer = () => {
    const initAuth = useAuthStore((s) => s.initAuth);
    return null;
};
